<template>
    <div>
        <h4 class="mb10">玩咖素材</h4>
        <div v-if="type">
            <el-form :model="formInline" size="mini" style="width: 100%;">

                <el-form-item label="">
                    <el-row :gutter="10">
                        <el-col :span="21"><el-input v-model.trim="formInline.material_md5"
                                placeholder="输入素材MD5查询"></el-input></el-col>
                        <el-col :span="3"><el-button :loading="loading" type="primary" @click="onSubmit">查询</el-button></el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="">
                    <el-input style="visibility: hidden;" />
                </el-form-item>

            </el-form>
        </div>
        <div v-loading="loading">
            <preview :info="info?.material_info"/>
            <div class="info_item">
                <h5 class="info_title">素材信息</h5>
                <div class="info_item_con">
                    <div class="label">素材名称：</div>
                    <div class="value">{{ info?.material_info?.material_name }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">MD5：</div>
                    <div class="value">{{ info?.material_info?.material_md5 }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">上传时间：</div>
                    <div class="value">{{ info?.material_info?.upload_time }}</div>
                </div>

                <h5 class="info_title">制作人信息</h5>
                <div class="info_item_con">
                    <div class="label">制作人：</div>
                    <div class="value">{{ getTextConent }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">内部来源：</div>
                    <div class="value">{{ info?.producer_info?.source }}</div>
                </div>

                <h5 class="info_title">工单信息</h5>
                <div class="info_item_con">
                    <div class="label">工单ID：</div>
                    <div class="value">{{ info?.order_info?.order_id }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">任务ID：</div>
                    <div class="value">{{ info?.order_info?.detail_id }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">需求方：</div>
                    <div class="value">{{ info?.order_info?.create_order_user }}</div>
                </div>

                <h5 class="info_title">项目信息</h5>
                <div class="info_item_con">
                    <div class="label">项目：</div>
                    <div class="value">{{ info?.project_info?.project_name_show }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">产品类型：</div>
                    <div class="value">{{ info?.project_info?.app_type_text }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">游戏类型：</div>
                    <div class="value">{{ info?.project_info?.game_classify_text }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">媒体：</div>
                    <div class="value">{{ info?.project_info?.plat_name }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">投放场景：</div>
                    <div class="value">{{ info?.project_info?.delivery_scene_text }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">投放版位：</div>
                    <div class="value">{{ info?.project_info?.delivery_type_text }}</div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import preview from './preview.vue';
import { compareSearchMaterialMd5Api } from '@/api/systemTool/compare'
export default {
    name: 'wankaInfo',
    components: {
        preview
    },
    props: {
        type: {
            type: Boolean,
            default: true
        },
        prewInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            formInline: {
                material_md5: '',
            },
            loading: false,
            info:{}
        }
    },
    computed: {
        getTextConent() {
            let producer_list = this.info?.producer_info?.producer_list
            let text = ''
            if (Array.isArray(producer_list) && producer_list.length != 0) {
                producer_list.forEach(item => {
                    let ratio = item.ratio ? (item.ratio * 100).toFixed(2) : ''
                    if (ratio) {
                        text += `${item.name}(${ratio}%);`
                    } else {
                        text += `${item.name};`
                    }
                })
            } else {
                text = '-'
            }
            return text
        },
    },
    watch: {
        prewInfo:{
            handler(n){
                this.info = this.prewInfo
            },
            immediate:true,
            deep: true
        }
    },
    methods: {
        onSubmit() {
            this.loading = true
            compareSearchMaterialMd5Api({ material_md5: this.formInline.material_md5 }).then(res => {
                if(!res.data.material_info)  {
                    this.$message.error('未查到相关素材')
                    return;
                }
                this.info = res.data
                this.$emit('getUrl', this.info.material_info)
            }, err => {
                this.$message.error(err.info)
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.info_item {
    padding: 0 6px;

    .info_title {
        margin-bottom: 10px;
    }

    .info_item_con {
        display: flex;
        align-items: flex-start;
        width: 100%;
        font-size: 12px;
        padding-bottom: 2px;
        padding-left: 12px;
        line-height: 22px;
        margin-bottom: 6px;

        .label {
            min-width: 64px;
            display: block;

        }

        .value {
            /*flex: 1;*/
            overflow-x: hidden;
            word-wrap: break-word;
            display: block;
            color: #333;
        }

        .overflowCon {
            overflow-x: auto;

            .overflowCon_a {
                //min-width: 250px;
                display: flex;
                flex-direction: column;

                a {
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>